import useSWR from 'swr';

import { usePrivate } from '@/components/private/PrivateContext';
import { enqueueSnackbar } from '@/providers/SnackbarProvider';

import { useGetAnimalByEntityIdMessages } from './messages';

export interface useGetAnimalByEntityIdOptions {
  shouldFetch?: boolean;
}

export function getAnimalByEntityIdCacheKey(animalEntityId: string) {
  return `/api/Animal/${animalEntityId}`;
}

export function useGetAnimalByEntityId(
  animalEntityId?: string,
  options?: useGetAnimalByEntityIdOptions,
) {
  const mergedOptions: useGetAnimalByEntityIdOptions = {
    shouldFetch: true,
    ...options,
  };

  const { entityApi } = usePrivate();

  // const results = useSWR(
  //   entityApi && animalEntityId && mergedOptions.shouldFetch
  //     ? getAnimalByEntityIdCacheKey(animalEntityId)
  //     : null,
  //   () => entityApi?.apiEntityGetEntityFilterByDetailPost(animalEntityId),
  //   {
  //     onError: (error) => {
  //       enqueueSnackbar(
  //         useGetAnimalByEntityIdMessages[
  //           'useGetAnimalByEntityId.fetch.unexpectedError'
  //         ],
  //         {
  //           variant: 'error',
  //         },
  //       );
  //       console.error(
  //         '[BREEDLOGIC] <useGetAnimalByEntityId> error fetching animal.',
  //         error,
  //       );
  //     },
  //   },
  // );

  const results = {} as any;

  const isLoadingOrValidating =
    results.isLoading || results.isValidating || !entityApi;

  return { ...results, isLoadingOrValidating };
}
